import { Board, BoardType } from "@sportactics/board-editing";
import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

export function useBoardLocalPersistence(): useBoardLocalPersistenceReturn {
  return useLazyContext(BoardLocalPersistenceContext);
}

export type useBoardLocalPersistenceReturn = {
  upsertBoard: (board: Board) => Promise<void>;
  hasBoard: (boardType: BoardType) => Promise<boolean>;
  getBoard: (boardType: BoardType) => Promise<Board>;
  deleteBoard: (boardType: BoardType) => Promise<void>;
};

export const BoardLocalPersistenceContext =
  createContext<LazyValue<useBoardLocalPersistenceReturn>>(undefined);
